import React ,{ useState }from 'react'
import Accordion from 'react-bootstrap/Accordion';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ReviewOne from '../assets/images/review-1.svg'
import { Rating } from 'react-simple-star-rating'
function ProductInformation({ productRow }) {  
  const [key, setKey] = useState('productDetails');
  return (
    <>
     <section className='product-information'>        
        <div className="product-information-wrap">
          <h2 className='d-none d-md-block'>Product Information</h2>
          <p className='d-none d-md-block'>Find the perfect products for every chapter.</p>
          <Accordion className='product-information-accordion d-md-none' defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>Product Details</Accordion.Header>
              <Accordion.Body>
                <ProductDetailsCon productRow={productRow} />
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>Ingredients</Accordion.Header>
              <Accordion.Body>
                <IngredientsCon productRow={productRow} />
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>Directions</Accordion.Header>
              <Accordion.Body>
                <DirectionsCon productRow={productRow} />
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>FAQ’s</Accordion.Header>
              <Accordion.Body>
                <FAQCon productRow={productRow} />
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>Reviews</Accordion.Header>
              <Accordion.Body>
                <ReviewsCon productRow={productRow} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <div className="d-none d-md-block">
            <Tabs
              defaultActiveKey="productDetails"
              id="uncontrolled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
            >
              <Tab eventKey="productDetails" title="Product Details">
                <ProductDetailsCon productRow={productRow} />
              </Tab>
              <Tab eventKey="ingredients" title="Ingredients">
                <IngredientsCon productRow={productRow} />
              </Tab>
              <Tab eventKey="directions" title="Directions">
                <DirectionsCon productRow={productRow} />
              </Tab>
              <Tab eventKey="faqs" title="FAQ’s">
                <FAQCon productRow={productRow} />
              </Tab>
              <Tab eventKey="reviews" title="Reviews">
                <ReviewsCon productRow={productRow} />
              </Tab>
            </Tabs>
          </div>
        </div>
     </section>     
    </>
  )
}
export default ProductInformation


const ProductDetailsCon = ({ productRow }) => {
  return (
<>
 
    <div className="product-desc-content" dangerouslySetInnerHTML={{ __html: productRow?.description || '' }}></div>
</>
  );
}
const IngredientsCon = ({ productRow }) => {
  return (
   <div className="ingredients-wrap">
    <div className="ingredients-desc-content" dangerouslySetInnerHTML={{ __html: productRow?.ingredients || '' }}></div>
    {productRow?.other_ingredients ? (
      <div className='other-group'>
        <h3>OTHER INGREDIENTS</h3>
        <p>{productRow?.other_ingredients}</p>
      </div>
    ) : null}
    {productRow?.does_not_contain ? (
      <div className='other-group'>
        <h3>{productRow?.title} DOES NOT CONTAIN</h3>
        <p>{productRow?.does_not_contain}</p>
      </div>
    ) : null}
    <div className='other-group'>
      <h3>OTHER DETAILS</h3>
      <p>UPC: {productRow?.UPC || '-'}</p>
      <p>SKU: {productRow?.SKU || '-'}</p>
    </div>
  </div>
  );
}
const DirectionsCon = ({ productRow }) => {
  return (
    <>
      <div className='other-group'>
        <div className="directions-desc-content" dangerouslySetInnerHTML={{ __html: productRow?.direction || '' }}></div>
      </div>
    </>
  );
}
const FAQCon = ({ productRow }) => {
  return (
    <>
    <div className='faqs-wrap'>
      {productRow?.faqs?.length > 0 ? (
        <Accordion defaultActiveKey="0">
          {productRow?.faqs?.map((faq, indexFaq) => (
            <Accordion.Item eventKey={indexFaq.toString()} key={faq.id || indexFaq}>
              <Accordion.Header>
                <span>{indexFaq + 1 < 10 ? `0${indexFaq + 1}` : indexFaq + 1}</span>
                {faq.question}
              </Accordion.Header>
              <Accordion.Body>
                <p dangerouslySetInnerHTML={{ __html: faq.answer || '' }} />
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      ) : null}
    </div>
    </>
  );
}
const ReviewsCon = ({ productRow }) => {
  return (
    <>
    {productRow?.reviews?.length > 0 ? (
      <div className="reviews-wrap">
        {productRow?.reviews?.map((review, indexReview) => (
          <div className="reviews-item" key={`r${indexReview}`}>
            <div className="reviews-item-header">
              <img src={ReviewOne} alt="" />
              <h3>{review.name}</h3>
              <span>{review.time_since}</span>
            </div>
            <div className="reviews-item-body">
              <div className="product-review">
                <Rating
                  readonly={true}
                  initialValue={review.rating}
                  showTooltip
                  tooltipDefaultText={`${review.rating}`}
                />
              </div>
              <p>{review.description}</p>
              {review?.images?.length > 0 ? (
                <img src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${review.images[0]}`} alt="" />
              ) : null}
            </div>
          </div>
        ))}
      </div>
    ) : null}
    </>
  );
}